import resize from "../resize";
import Swiper, { Navigation, Pagination, Lazy } from "swiper";
Swiper.use([Pagination, Navigation, Lazy]);

const initEducationSlider = () => {
  const slider = document.querySelector(".education-slider");
  let swiper = null;

  function init() {
    if (!swiper) {
      swiper = new Swiper(slider, {
        autoHeight: false,
        loop: false,
        lazy: true,
        spaceBetween: 15,
        breakpoints: {
          0: {
            slidesPerView: 1
          },
          360: {
            slidesPerView: 1.2
          },
          665: {
            slidesPerView: 2
          },
        },
        pagination: {
          el: ".education .education-pagination",
          bulletActiveClass: "active",
          clickable: true,
        },
      });
    }
  }

  function destroy() {
    if (swiper) {
      swiper.destroy();
      swiper = null;
    }
  }

  function resizeSwiper() {
    window.innerWidth <= 750
      ? init()    
      : destroy();
  }

  slider && resizeSwiper();
  slider && resize(resizeSwiper);
};

export default initEducationSlider;
